<template>
  <div class="camsSetting">
    <router-view :route-loading="loading"></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'CamsSetting',
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('settings', ['fetchCameraGroup']),
    async init() {
      try {
        this.loading = true;
        // avoid fetching camera group data when navigating to specific routes
        // such as settings-cams-list and settings-cams-order because they are already
        // handled in their respective components
        // and we don't want to fetch the data again
        if (
          !['settings-cams-list', 'settings-cams-order'].includes(
            this.$route.name
          )
        ) {
          await this.fetchCameraGroup({});
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.camsSetting {
  height: 100%;
}
</style>
